<app-review-overview *ngIf="reviews.length > 0" class="reviews__summary" [reviewSummary]="reviewSummary" [isHeader]="false" (sortReviewsBy)="onSortReviewsBy($event)"></app-review-overview>
<ul class="reviews__listing" *ngIf="reviews.length > 0; else reviewPlaceholder">
  <li [class]="isFlightDeckAdmin && review.interactions.reportedOffensive ? 'reviews__review-offensive-background' : 'reviews__review'" *ngFor="let review of this.sortedReviews">
    <div class="reviews__review-header">
      <div class="reviews__review-first-line">
        <div *ngIf="review.rating; else spacePlaceholder" class="reviews__review-rating">
          <star-rating
            [starType]="'svg'"
            [rating]="review.rating"
            [step]="0.1"
            [showHalfStars]="true"
            [staticColor]='"ok"'
            [size]='"medium"'
            [readOnly]="true">
          </star-rating>
        </div>
        <div class="reviews__review-date">{{ review.modDate | date: 'shortDate' }}</div>
      </div>
      <div class="reviews__review-title" *ngIf="review.title">{{ review.title }}</div>
      <div class="reviews__review-name">{{ review.userName }}.</div>
    </div>
    <!-- <div *ngIf="review.review" class="reviews__review-body" [class.show]="review.displayFull">{{ review.review }}</div> -->
    <app-truncated-text *ngIf="review.review" class="reviews__review-body" [text]="review.review" [limit]="250"></app-truncated-text>
    <div class="reviews__photo-gallery-spacer"></div>
    <ngx-gallery *ngIf="review.galleryPhotos && review.galleryPhotos.length" [options]="galleryOptions" [images]="review.galleryPhotos"></ngx-gallery>
    <!-- <button (click)="review.displayFull = !review.displayFull">{{ review.displayFull ? 'Show less': 'Show More' }}</button> -->
    <ng-container *ngIf="!isMyReview(review); else myReview">
      <div class="reviews__review-last-line" *ngIf="business && business.id; else airportPlaceholder">
        <div class="reviews__review-thumbs">
          <app-thumbsup-icon [entityId]="business.id" [isAirport]="false" [isLiked]="review.interactions.myUpVote" [review]="review" (toggle)="reloadEntity()"></app-thumbsup-icon>
          {{ review.interactions.upVotes }}
          <app-thumbsdown-icon [entityId]="business.id" [isAirport]="false" [isLiked]="review.interactions.myDownVote" [review]="review" (toggle)="reloadEntity()"></app-thumbsdown-icon>
          {{ review.interactions.downVotes }}
        </div>
        <div class="reviews__review-offensive" *ngIf="!(isFlightDeckAdmin && editModeSet) && !review.interactions.myReportedOffensive; else reportedOffensiveBusinessPlaceholder"
             (click)="reportOffensive(false, review)">Report Offensive</div>
        <div class="reviews__review-offensive" *ngIf="isFlightDeckAdmin && editModeSet && review.interactions.reportedOffensive"
             (click)="clearOffensive(false, review)">Clear User Reports</div>
        <div *ngIf="isFlightDeckAdmin && editModeSet">
          <mat-icon (click)="moveReview(false, review)" class="move-icon" mat-tooltip="Move Review" aria-label="Move Review">dynamic_feed</mat-icon>
          <mat-icon (click)="deleteReview(false, review)" class="delete-icon" mat-tooltip="Delete" aria-label="Delete Review">delete_outline</mat-icon>
        </div>
      </div>
      <ng-template #airportPlaceholder>
        <div class="reviews__review-last-line" *ngIf="airport && airport.airportId">
          <div class="reviews__review-thumbs">
            <app-thumbsup-icon [entityId]="airport.airportId" [isAirport]="true" [isLiked]="review.interactions.myUpVote" [review]="review" (toggle)="reloadEntity()"></app-thumbsup-icon>
            {{ review.interactions.upVotes }}
            <app-thumbsdown-icon [entityId]="airport.airportId" [isAirport]="true" [isLiked]="review.interactions.myDownVote" [review]="review" (toggle)="reloadEntity()"></app-thumbsdown-icon>
            {{ review.interactions.downVotes }}
          </div>
          <div class="reviews__review-offensive" *ngIf="!(isFlightDeckAdmin && editModeSet) && !review.interactions.myReportedOffensive; else reportedOffensiveAirportPlaceholder"
               (click)="reportOffensive(true, review)">Report Offensive</div>
          <div class="reviews__review-offensive" *ngIf="isFlightDeckAdmin && editModeSet && review.interactions.reportedOffensive"
               (click)="clearOffensive(true, review)">Clear User Reports</div>
          <div *ngIf="isFlightDeckAdmin && editModeSet">
            <mat-icon (click)="moveReview(true, review)" class="move-icon" mat-tooltip="Move Review" aria-label="Move Review">dynamic_feed</mat-icon>
            <mat-icon (click)="deleteReview(true, review)" class="delete-icon" mat-tooltip="Delete" aria-label="Delete Review">delete_outline</mat-icon>
          </div>
        </div>
      </ng-template>
      <ng-template #reportedOffensiveAirportPlaceholder>
        <div *ngIf="!(isFlightDeckAdmin && editModeSet)" class="reviews__review-offensive" (click)="removeOffensive(true, review)">Cancel Report</div>
      </ng-template>
      <ng-template #reportedOffensiveBusinessPlaceholder>
        <div *ngIf="!(isFlightDeckAdmin && editModeSet)" class="reviews__review-offensive" (click)="removeOffensive(false, review)">Cancel Report</div>
      </ng-template>
    </ng-container>
    <ng-template #myReview>
      <div class="reviews__review-last-line">
        <div class="reviews__review-thumbs">
          <div class="reviews__thumbs-container">
            <div class="reviews__thumb-container">
              <mat-icon [matTooltip]="'Unable to like your own review'" class="reviews__thumbs-icon">thumb_up</mat-icon>
            </div> {{ review.interactions.upVotes }}
          </div>
          <div class="reviews__thumbs-container">
            <div class="reviews__thumb-container">
              <mat-icon [matTooltip]="'Unable to dislike your own review'" class="reviews__thumbs-icon">thumb_down</mat-icon>
            </div> {{ review.interactions.downVotes }}
          </div>
        </div>
      </div>
    </ng-template>
    <div *ngIf="review.response || (editModeSet && ((this.isAirportManager || this.isBusinessManager) && !this.isFlightDeckAdmin))" class="reviews__review-response">
      <div class="reviews__review-response-first-line">
        <div class="reviews__review-response-title">
          {{ entityType }} manager response:
        </div>
        <div>
          <mat-icon (click)="openEditReviewResponseDialog(review)" *ngIf="editModeSet && ((this.isAirportManager || this.isBusinessManager) && !this.isFlightDeckAdmin) && (review.userId !== recId)" class="edit-icon" mat-tooltip="Edit" aria-label="Edit response">edit</mat-icon>
        </div>
      </div>
      <div class="reviews__review-response-text" *ngIf="review.response"><app-truncated-text [text]="review.response" [limit]="250"></app-truncated-text></div>
      <div class="reviews__review-response-last-line">
        <div class="reviews__review-response-name" *ngIf="review.responseOper && review.response">{{ review.responseOper }}.</div>
        <div class="reviews__review-response-date" *ngIf="review.responseDate && review.response">{{ review.responseDate | date: 'shortDate' }}</div>
      </div>
    </div>
  </li>
</ul>
<div class="reviews__post-container">
  <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" (click)="openWriteReview()">
    <ng-container *ngIf="hasReviewed; else postPlaceholder">Edit Review</ng-container>
  </button>
</div>
<ng-template #reviewPlaceholder>
  <div class="detail-page__placeholder reviews__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">Be the first to review.</div>
  </div>
</ng-template>
<ng-template #postPlaceholder>
  Post Review
</ng-template>
<ng-template #spacePlaceholder>
  &nbsp;
</ng-template>
